<template>
	<div id="NikanStimulContainer"></div>
</template>

<script>
	import Merge from 'lodash/merge'
	import Stimul from '~/plugins/stimul'
	export default {
		data() {
			return {
				stimulInstance: null,
				settings: {
					mode: 'viewer',
					reportObject: null,
					eventHandlers: null,
					getDataSources: null,
					isBulk: false
				}
			}
		},
		props: {
			options: {
				type: Object
			}
		},
		watch: {
			options: {
				immediate: true,
				handler(val) {
					this.settings = Merge({}, this.settings, val)
				}
			}
		},
		mounted() {
			this.prepareWindow(this.$t(`stimul.title.${this.settings.mode}`))
			this.stimulInstance = new Stimul(this.settings.eventHandlers, this.settings.getDataSources, this.settings.additionalData, this.settings.isBulk)

			if (this.settings.mode === 'designer')
				this.showDesigner(this.settings.reportObject)
			else
				this.showViewer(this.settings.reportObject)
		},
		methods: {
			showDesigner(reportObject) {
				this.stimulInstance.showDesigner(reportObject)
			},
			showViewer(reportObject) {
				this.stimulInstance.showViewer(reportObject)
			},
			prepareReport(reportObject) {
				this.stimulInstance.prepareReport(reportObject)
			},
			async isDataChanged() {
				// show dialog on close when using designer
				return this.options.mode === 'designer'
			},
		},
		unmounted() {
			this.stimulInstance.destroy(this.options.mode)
		}
	}
</script>

<style scoped>
	#NikanStimulContainer {
		position: relative;
		height: 100%;
	}
</style>